export default __webpack_public_path__ + "static/media/a028-5.c1c72cf7.png";